import React from 'react';
import { Search, X, Plus, Printer } from 'lucide-react';

const CTRL = 'h-9 rounded-lg border border-input bg-background px-3 text-sm text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ring))] focus-visible:ring-offset-1 focus-visible:ring-offset-background';

// Filter + primary-action bar. Rendered either as a sticky bar below the header
// (concepts A / C) or embedded in the header's second row (concept B).
export function TagToolbar({
  search, setSearch, dateFrom, setDateFrom, dateTo, setDateTo, onReset,
  count, total, canCreate, onCreate, onBatch, batchDisabled,
}) {
  const hasFilter = !!(search || dateFrom || dateTo);
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="tagws-toolbar">
      <div className="relative min-w-[200px] flex-1">
        <Search size={15} className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input
          value={search} onChange={(e) => setSearch(e.target.value)}
          placeholder="Search number, title, type…"
          className={`${CTRL} w-full pl-8`} data-testid="tagws-filter-search-input"
        />
      </div>
      <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} className={`${CTRL} w-[150px]`} aria-label="Received from" data-testid="tagws-filter-received-from" />
      <span className="text-xs text-muted-foreground">to</span>
      <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} className={`${CTRL} w-[150px]`} aria-label="Received to" data-testid="tagws-filter-received-to" />
      {hasFilter && (
        <button onClick={onReset} data-testid="tagws-filter-reset-button" className="inline-flex h-9 items-center gap-1 rounded-lg px-2.5 text-sm text-muted-foreground transition-colors duration-150 hover:bg-secondary hover:text-foreground">
          <X size={14} /> Reset
        </button>
      )}
      <span className="inline-flex items-center rounded-full border border-border bg-secondary px-2.5 py-1 font-mono text-xs text-muted-foreground" data-testid="tagws-result-count">
        {count}{typeof total === 'number' ? ` / ${total}` : ''}
      </span>
      <div className="ml-auto flex items-center gap-2">
        {canCreate && (
          <button onClick={onCreate} data-testid="tagws-create-manual-tag-open-button" className="inline-flex h-9 items-center gap-1.5 rounded-lg bg-primary px-3 text-sm font-semibold text-primary-foreground transition-colors duration-150 hover:opacity-90 active:scale-[0.98]">
            <Plus size={15} /> Create manual tag
          </button>
        )}
        <button onClick={onBatch} disabled={batchDisabled} data-testid="tagws-batch-print-open-button" className="inline-flex h-9 items-center gap-1.5 rounded-lg border border-[hsl(var(--ring))] bg-[hsl(var(--accent))] px-3 text-sm font-medium text-foreground transition-colors duration-150 hover:opacity-90 disabled:opacity-50 active:scale-[0.98]">
          <Printer size={15} /> Batch print
        </button>
      </div>
    </div>
  );
}
